import { get } from './commonFetch';

export const getBrandingImage = (): Promise<string> => {
  return get('/api/brandingImages');
};
